import { MoniebookLoader } from '@moniebook-web/components/molecules/moniebook-loader';

import { useGhostSessionInit } from './use-ghost-session-init';

export function GhostSessionInit() {
    useGhostSessionInit();

    return <MoniebookLoader fullHeight />;
}
